<div class="w-full max-w-4xl rounded-xl border border-gray-200 bg-white p-6 shadow-2xl">
  <div class="mb-6 flex items-center justify-between">
    <h3 class="text-xl font-bold text-gray-800">{{ isEditMode ? 'Uredi klub' : 'Dodaj klub' }}</h3>
    <button type="button" aria-label="Zapri dialog" class="text-gray-400 hover:text-gray-600" [disabled]="isSaving" (click)="onCancel()">
      <i class="fas fa-times text-xl"></i>
    </button>
  </div>

  <div class="grid gap-4 sm:grid-cols-2">
    <label class="flex flex-col gap-1 font-semibold text-gray-700">
      Ime kluba
      <input type="text" required placeholder="npr. Strelsko društvo Mrož" autofocus class="rounded-lg border border-blue-200 bg-white px-3 py-2 font-normal" [(ngModel)]="name" [disabled]="isSaving" />
    </label>
    <label class="flex flex-col gap-1 font-semibold text-gray-700">
      Kratica kluba
      <input type="text" required maxlength="12" placeholder="npr. MROŽ" class="rounded-lg border border-blue-200 bg-white px-3 py-2 font-normal uppercase" [(ngModel)]="code" [disabled]="isSaving" />
    </label>
  </div>

  <p *ngIf="formError" class="mt-3 font-semibold text-red-600">{{ formError }}</p>

  <div class="mt-6 flex justify-end gap-3">
    <button type="button" class="rounded-lg border border-gray-300 bg-white px-4 py-2 font-semibold text-gray-700 hover:bg-gray-50" [disabled]="isSaving" (click)="onCancel()">Prekliči</button>
    <button type="button" class="rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60" [disabled]="isSaving || !name.trim() || !code.trim()" (click)="onSave()">
      <i class="fas fa-save mr-2"></i>{{ isSaving ? 'Shranjujem...' : 'Shrani' }}
    </button>
  </div>
</div>
